module.exports = __webpack_public_path__ + "assets/img/32dc331ca5e146280aeb15b32a876159.png";